import { render, staticRenderFns } from "./BaseDialogComponent.vue?vue&type=template&id=18a4eab9"
import script from "./BaseDialogComponent.vue?vue&type=script&lang=js"
export * from "./BaseDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports